import { Theme, ThemeProps } from "@radix-ui/themes";
import "@radix-ui/themes/styles.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./styles/fonts.css";
import { initDatadog } from "./datadog";

// const ENV = process.env.REACT_APP_ENVIRONMENT || "NONE";
// const systemSettingDark = window.matchMedia("(prefers-color-scheme: dark)");
// const isDark = systemSettingDark.matches;

initDatadog();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const getAppearance = (): ThemeProps["appearance"] => {
  return "light";
  // if (ENV !== "DEV") {
  //   return "light";
  // }
  // if (!isDark) {
  //   return "light";
  // }
  // return "dark";
};

root.render(
  <React.StrictMode>
    <Theme
      accentColor="red"
      panelBackground="solid"
      radius="small"
      appearance={getAppearance()}
    >
      <App />
    </Theme>
  </React.StrictMode>,
);
